export default __webpack_public_path__ + "static/media/a6_folding_card_portrait.4950685b.png";